import React from "react";
import { TurnrText } from "./TurnrText.jsx";

export default function MoneyWithCurrency({ money, currencyCode, bold }) {
    return (
        <div>
            <TurnrText Tag="span" bold={bold}>
                {money || 0}
            </TurnrText>
            <TurnrText Tag="span" weak size={"sm"}>
                &nbsp;&nbsp;{currencyCode}
            </TurnrText>
        </div>
    );
}
